
import { OLMSApiService } from '@/shared/apis'
import { RootState } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export type ProcessUnassignOrderPayload = {
  orderIds: EntityId[]
  shiftId: EntityId
}

export const processUnassignOrder = createAsyncThunk<void, ProcessUnassignOrderPayload, { state: RootState }>(
  'dragdrop/processUnassignOrder',
  async ({ orderIds, shiftId }, { getState }) => {
    const state = getState()
    const currentScreen = state.userInterface.currentScreen
    const endpoint = currentScreen === 'planning' ? '/planning/deallocate' : '/runsheet/deallocate'

    await OLMSApiService.post<null>(endpoint, {
      orderIds: orderIds,
      shiftId: shiftId,
    })
  },
)
